import {
  BenefitChecksPageAccess,
  GroupEmbedPageAccess,
  PatientDetailsPageAccess,
  PayerCredentialPageAccess,
  ProviderManagementPageAccess
} from '../models/route.model';

export const defaultGroupEmbedAccessAllowed: PatientDetailsPageAccess & GroupEmbedPageAccess = {
  appointment: true,
  basicEligibility: true,
  patientPlan: true,
  coverages: true,
  eligibilityLogs: true,
  complete: true,
  resync: true,
  newEligibilityCheck: true,
  statusChange: true,
  benefitEdit: true,
  appointmentNote: true,
  dailyHuddle: true,
  downloadAppointment: true,
  patients: true,
  informationIcon: true
};

export const defaultGroupEmbedAccessNotAllowed: PatientDetailsPageAccess & GroupEmbedPageAccess = {
  appointment: false,
  appointmentNote: false,
  basicEligibility: false,
  patientPlan: false,
  coverages: false,
  eligibilityLogs: false,
  complete: false,
  resync: false,
  newEligibilityCheck: false,
  statusChange: false,
  benefitEdit: false,
  dailyHuddle: false,
  downloadAppointment: false,
  patients: false,
  informationIcon: false
};

export const defaultPayerCredentialPageAccessNotAllowed: PayerCredentialPageAccess = {
  'list-payer-credential': false,
  'update-payer-credential': false,
  'add-payer-credential': false,
  'delete-payer-credential': false,
  'mfa-management': false
};

export const defaultBenefitChecksPageAccessNotAllowed: BenefitChecksPageAccess = {
  'yearly-benefit-check': false
};

export const defaultPayerCredentialPageAccessAllowed: PayerCredentialPageAccess = {
  'list-payer-credential': true,
  'update-payer-credential': false,
  'add-payer-credential': false,
  'delete-payer-credential': false,
  'mfa-management': false
};

export const defaultProviderManagementPageAccessNotAllowed: ProviderManagementPageAccess = {
  'provider-management': false,
  'add-update-provider': false
};

export const defaultAppFeaturesAccess: PayerCredentialPageAccess &
  GroupEmbedPageAccess &
  PatientDetailsPageAccess &
  BenefitChecksPageAccess &
  ProviderManagementPageAccess = {
  ...defaultPayerCredentialPageAccessNotAllowed,
  ...defaultGroupEmbedAccessNotAllowed,
  ...defaultBenefitChecksPageAccessNotAllowed,
  ...defaultProviderManagementPageAccessNotAllowed
};
